import debounce from 'lodash/debounce'
import { forwardRef, useRef } from 'react'
import { SearchInputField, SearchInputFieldProps } from 'utoniq-ui'

import { useForm, UseFormProps, useTranslation } from '@/core'
import { CellFrame, Organism, OrganismFrame } from '@/core/architecture'

export type ItemSelectFormProps = {
  onSubmit: (values: ItemSelectProps) => Promise<void>
}

type ItemSelectProps = {
  keyword: string
}

const schema: UseFormProps['schema'] = o => ({
  keyword: o.string().allow('').optional(),
})

export const ItemSelectForm: Organism<ItemSelectFormProps> = ({ onSubmit }) => {
  const { handleSubmit, register, setValue } = useForm<ItemSelectProps>({
    schema,
    defaultValues,
  })

  const handleChangeKeywordDebounce = useRef(
    debounce(
      handleSubmit(({ keyword }) => onSubmit({ ...defaultValues, keyword })),
      500
    )
  )

  return (
    <OrganismFrame sx={{ py: 5 }} onSubmit={handleSubmit(onSubmit)}>
      {/**
       * @todo
       * 「ItemSelectModalのalgolia化」完了までコメントアウト
       * https://app.clickup.com/t/908127/UT-6898
       *
       * <SearchInputCell
       * {...register('keyword')}
       * onChange={async event => {
       *   setValue('keyword', event.target.value)
       *   await handleChangeKeywordDebounce.current()
       * }}
       * />
       */}
    </OrganismFrame>
  )
}

const SearchInputCell = forwardRef(
  (props: Omit<SearchInputFieldProps, 't'>, ref) => {
    const { t } = useTranslation('consoleCollectionCreate')
    return (
      <CellFrame sx={{ width: '100%' }}>
        <SearchInputField {...props} ref={ref} t={t} />
      </CellFrame>
    )
  }
)

const defaultValues: ItemSelectProps = {
  keyword: '',
}
